import React from 'react';
import { Phone, Mail, Menu, X, ArrowRight } from 'lucide-react';
import Logo from './Logo';

const Header = ({ theme, toggleTheme, mobileMenuOpen, setMobileMenuOpen, handleNavClick, headerScrolled }) => {
  return (
    <header className={`header ${headerScrolled ? 'scrolled' : ''}`}>
      <div className="header-top">
        <div className="container">
          <div className="header-top-content">
            <div className="header-contact">
              <div className="header-contact-item">
                <Phone size={16} />
                <span>(518) 792-0200</span>
              </div>
              <div className="header-contact-item">
                <Mail size={16} />
                <span>fredbartlettenterprises@gmail.com</span>
              </div>
            </div>
            <div style={{ fontSize: '0.875rem' }}>Mon-Fri: 8AM-5PM | Sat-Sun: By Appointment</div>
          </div>
        </div>
      </div>

      <div className="header-main">
        <div className="container">
          <div className="header-content">
            <div className="logo-container" onClick={() => handleNavClick('home')}>
              <div className="logo-wrapper" onClick={(e) => { e.stopPropagation(); toggleTheme(); }} title={theme === 'light' ? 'Switch to Dark Mode' : 'Switch to Light Mode'}>
                <Logo />
                <div className="logo-overlay">
                  {theme === 'light' ? '☀️' : '🌙'}
                </div>
              </div>
              <div className="company-info">
                <div className="company-name">Bartlett Enterprises</div>
                <div className="company-tagline">Hire The Best For Less!</div>
              </div>
            </div>
            
            <nav className={`nav ${mobileMenuOpen ? 'mobile-open' : ''}`}>
              <a href="#home" onClick={(e) => { e.preventDefault(); handleNavClick('home'); }}>Home</a>
              <a href="#services" onClick={(e) => { e.preventDefault(); handleNavClick('services'); }}>Services</a>
              <a href="#contact" onClick={(e) => { e.preventDefault(); handleNavClick('contact'); }}>Contact</a>
            </nav>

            <div className="header-actions">
              <button className="cta-header" onClick={() => handleNavClick('contact')}>
                Get Quote <ArrowRight size={18} />
              </button>
              <button className="mobile-menu-btn" onClick={() => setMobileMenuOpen(!mobileMenuOpen)}>
                {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
              </button>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;